module.exports = require("node:stream/web");